module.exports = __webpack_public_path__ + "img/checked-checkbox.adc844eb.svg";